import React from 'react'

import { LoadingIndicator } from '@wf-common/atoms'
import { createLoadableComponentFactory, withModuleProps } from '@wf/modux'

import { translationActions } from './common/duckies/translations'

const ErrorComponent = () => <div>ERROR! Module failed to load...</div>

const createLoadable = (importFn: () => Promise<any>) =>
    createLoadableComponentFactory(null, ErrorComponent, <LoadingIndicator isLoading={true} />)(importFn)

const createLoadableWithTranslations = (importFn: () => Promise<any>) =>
    createLoadableComponentFactory(translationActions, ErrorComponent, <LoadingIndicator isLoading={true} />)(importFn)

const BaseModule = withModuleProps(createLoadable(() => import('./modules/base/module.js')))
const HomeModule = withModuleProps(createLoadable(() => import('./modules/home/module.js')))
const InfoModule = withModuleProps(createLoadable(() => import('./modules/info/module.js')))
const SignUpModule = withModuleProps(createLoadable(() => import('./modules/sign-up/module.js')))
const ApplicationsModule = withModuleProps(
    createLoadableWithTranslations(() => import('./modules/applications/module.js'))
)
const DeveloperModule = withModuleProps(createLoadable(() => import('./modules/developer/module.js')))

export { BaseModule, HomeModule, InfoModule, SignUpModule, ApplicationsModule, DeveloperModule }
